import { MDBAlert, MDBBtn, MDBIcon, MDBModalFooter, MDBSpinner } from 'mdb-react-ui-kit';
import { useState } from 'react';
import { useTranslation } from "react-i18next";
import { deletePortingDetails } from "../../../apiclients/streamsapi_bridge";

export default function DeleteOrder(props) {
    const [internalError, setInternalError] = useState(false);
    const { t } = useTranslation();
    const [isloading, setIsloading] = useState(false);

    async function removeOrderDetails(event) {
        try {
            event.preventDefault();
            event.stopPropagation();
            setInternalError(false);
            console.log(`Order Id ::${props.orderId}`);
            setIsloading(true);
            let deleteOrderRes = await deletePortingDetails(JSON.parse(sessionStorage.getItem("admin_session")).siteid, props.orderId);
            setTimeout(() => { setIsloading(false) }, 1000);
            let delInfo = await deleteOrderRes.json();
            if (deleteOrderRes.status == 200) {
                if (delInfo.status == 'success') {
                    localStorage.setItem("s_message", delInfo.message);
                } else {
                    localStorage.setItem("f_message", delInfo.message);
                }
            } else if (delInfo.status == 400) {
                localStorage.setItem("f_message", delInfo?.message?.errors?.[0]?.message ?? delInfo?.message);
            } else if (delInfo.status == 500) {
                setInternalError(true);
            }
            props.onClose();
            window.location.href = "/phonenumbers";

        } catch (e) {
            console.log(`Unable to process Request :Internal server Error:!`);
            setInternalError(true);
        }
    }
    return (<>

        <div>
            <div className="d-flex align-items-center bg-danger bg-opacity-25 p-3  rounded-3 square border border-2 border-danger">
                <MDBIcon fas icon="ban" className="me-3" size="lg" color="danger" />
                <span>{`This will remove the ${props.portingName} Order and cannot be undone.`}</span>
            </div>
            <MDBModalFooter className='mt-3 pb-0 px-0'>
                <MDBBtn color="secondary" onClick={props.onClose}>
                    {t("cancel")}
                </MDBBtn>
                <MDBBtn onClick={(e) => removeOrderDetails(e)}>{t("remove")}</MDBBtn>
            </MDBModalFooter>
        </div>

        {isloading && (
            <>
                <div className="loadingclass">
                    <MDBBtn disabled>
                        <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                        Loading...
                    </MDBBtn>
                </div>
            </>
        )}

        {internalError && (<MDBAlert
            open
            className="alert-center"
            color="danger"
            autohide
            position="bottom-right"
            delay={5000}
        >Internal Server Error</MDBAlert>)}

    </>);
}